import { Headphones, CheckCircle2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { AudioData } from './types';
import { useTranslation } from 'react-i18next';

interface AudioContentProps {
  audio: AudioData;
  onEnded?: () => void;
  onManualComplete?: () => void;
  isCompleted?: boolean;
}

export function AudioContent({ audio, onEnded, onManualComplete, isCompleted }: AudioContentProps) {
  const { t } = useTranslation();

  if (!audio.audio_url) {
    return (
      <div className="flex items-center justify-center h-48 bg-muted rounded-lg">
        <p className="text-muted-foreground">{t('common:activityViewer.noAudio', 'No audio available')}</p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-center py-8 bg-gradient-to-br from-primary/10 to-secondary/10 rounded-xl">
        <div className="p-6 rounded-full bg-primary/20">
          <Headphones className="w-16 h-16 text-primary" />
        </div>
      </div>
      <audio 
        controls 
        className="w-full"
        src={audio.audio_url}
        autoPlay
        onEnded={onEnded}
      >
        {t('common:activityViewer.unsupportedAudio', 'Your browser does not support the audio element.')}
      </audio>
      <Button
        variant="outline"
        className="w-full"
        onClick={onManualComplete}
        disabled={isCompleted}
      >
        <CheckCircle2 className="w-4 h-4 mr-2" />
        {isCompleted 
          ? t('common:activityViewer.completedBadge', 'Completed')
          : t('common:activityViewer.markComplete', 'Mark as Completed')
        }
      </Button>
    </div>
  );
}
